import React from "react";

function WeatherTemperature(props) {

    function showCelsius(event) {
        event.preventDefault();
        props.setUnit("celsius");
        
      }
      
      function showFahrenheit(event) {
        event.preventDefault();
        props.setUnit("imperial");

    }

    if (props.unit === 'imperial') {
        return (
          <span className="temperature-container">
            <div className="current-temperature">
              {Math.round(props.data.temperature)}
            </div>
            <div className="current-temperature-unit"><span className="active-unit">&deg;F</span><a href="/" rel="no-referrer" className="temperature-link" onClick={showCelsius}> | &deg;C</a></div>
          </span>
        );
    } else {
        function convertToCelsius(fahrenheit) {
          return (fahrenheit - 32) * 5 / 9;
        }

         return (
           <span className="temperature-container">
             <div className="current-temperature">
               {Math.round(convertToCelsius(props.data.temperature))}
             </div>
             <div className="current-temperature-unit">
               <span className="active-unit">&deg;C</span>
               <a
                 className="temperature-link"
                 href="/"
                 rel="no-referrer"
                 onClick={showFahrenheit}
               >
                 {" "}
                 | &deg;F
               </a>
             </div>
           </span>
         );
    }

}

export default WeatherTemperature;
